export const IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
export const MS_TO_SEC_FACTOR = 1000;
export const DEFAULT_BG_COLOR = '#00000000';
